import NavA from "./NavA";
import NavB from "./NavB";
import NavC from "./NavC";

export default function Navbar() {
  return (
    <>
      <NavA />
      <NavB />
      <NavC />
    </>
  );
}
